export default {
  orders: 'Zamówienia',
  allOrders: 'Wszystkie zamówienia',
  onlyInJobReports: 'Części są wymieniane tylko w raportach pojedynczego zadania.',
};
